import VerificationCodeInput from './VerificationCodeInput'
export default VerificationCodeInput
